export default __webpack_public_path__ + "static/media/record.7cd29a54.svg";